var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNewDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 49,
  viewBox: "0 0 42 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.3333 48H7.66667C3.98667 48 1 44.992 1 41.2857V7.71429C1 4.008 3.98667 1 7.66667 1C7.66667 1 16.4133 1 22.3367 1C25.75 1 29.0233 2.36636 31.4333 4.79357C33.25 6.62321 35.4167 8.80536 37.2333 10.635C39.6433 13.0622 41 16.3589 41 19.7966C41 27.6322 41 41.2857 41 41.2857C41 44.992 38.0133 48 34.3333 48Z",
  stroke: "currentColor",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9 21C20.9 20.7239 21.1239 20.5 21.4 20.5H21.6C21.8761 20.5 22.1 20.7239 22.1 21V24.3H20.9V21ZM20.9 25.3H22.1V26.7H20.9V25.3ZM23.1 26.7V25.3H26C26.2761 25.3 26.5 25.5239 26.5 25.8V26.2C26.5 26.4761 26.2761 26.7 26 26.7H23.1ZM20.9 27.7H22.1V31C22.1 31.2761 21.8761 31.5 21.6 31.5H21.4C21.1239 31.5 20.9 31.2761 20.9 31V27.7ZM19.9 25.3V26.7H17C16.7239 26.7 16.5 26.4761 16.5 26.2V25.8C16.5 25.5239 16.7239 25.3 17 25.3H19.9Z",
  fill: "#5B9AFF",
  stroke: "currentColor"
})));
export { SvgNewDocument as ReactComponent };